import { isPhoneNumber } from 'class-validator';

const isValidPhone = (value: string) => {
  return isPhoneNumber(value, 'ES');
};

const isValidNumberOfPassengers = (adults: number, minors: number) => {
  if (adults + minors === 0 || adults === 0) {
    return false;
  }
  return true;
};

function isValidString(str: string) {
  return str !== null && str !== undefined && str.trim() !== '';
}

export { isValidPhone, isValidNumberOfPassengers, isValidString };
